import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { Plan } from '../common/models/plan';
import { User } from '../common/models/user';
import { PdfGenerationService } from '../common/services/pdf-generation.service';
import { PlanEditService } from '../common/services/plan-edit.service';
import { PlanService } from '../common/services/plan.service';
import { forkJoin, Observable, Subscription } from 'rxjs';
import { UserService } from '../common/services/user.service';
import { saveAs } from 'file-saver';
import { PdfResponse } from '../common/models/pdfResponse';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from '../snackbar/snackbar.component';
import { forEach } from 'lodash';
import { MemberProfile } from '../common/models/profile';
import { MatDialog } from '@angular/material/dialog';
import { DialogLoadingComponent } from '../dialogs/dialog-loading/dialog-loading.component';

@Component({
    selector: 'app-view-plan',
    templateUrl: './view-plan.component.html',
    styleUrls: ['./view-plan.component.css'],
    standalone: false
})
export class ViewPlanComponent implements OnInit {
  plan: Plan;
  user: User;
  submittedDate: string;
  lastEditedDate: string;
  profile: MemberProfile;
  isLoading = true;
  isDownloadingPdf = false;
  isSendingPdfEmail = false;


  paramsSubscription: Subscription;

  constructor(private planEditService: PlanEditService, private router: Router, private planService: PlanService, private pdfService: PdfGenerationService, private route: ActivatedRoute, private userService: UserService, private _snackBar: MatSnackBar, public dialog: MatDialog) {}

  ngOnInit(): void {
    this.userService.user().subscribe({
      next: (u) => {
        this.user = u;
      }
    });
    this.paramsSubscription = this.route.params.subscribe(params => {
      this.planService.getPlan(params['id']).subscribe({
        next: (p) => {
          this.plan = p
          this.submittedDate = moment.utc(p.SubmissionDate).local().format("MMMM DD, YYYY");
          if(p.LastEditDate)
            this.lastEditedDate = moment.utc(p.LastEditDate).local().format("MMMM DD, YYYY");
          this.isLoading = false;
        }
      });
      this.userService.profile().subscribe({next: profile => this.profile = profile });
    });
  }

  editLearning(): void {
    this.planEditService.setIsEditing(true, 6, this.plan.PlanYear);
    this.router.navigateByUrl('app/selfassessment');
  }

  editPlan(): void {
    this.planEditService.setIsEditing(true, 3, this.plan.PlanYear);
    this.router.navigateByUrl('app/selfassessment');
  }

  downloadPdf(isSimplified?: boolean) {
    this.isDownloadingPdf = true;
    this.dialog.open(DialogLoadingComponent, {
      width: "600px",
      disableClose: true,
      data: {
        message: "Your selected CPD plan(s) are being generated. You can access the CPD plan(s) by viewing your Downloads folder.",
        srMessage: "Your selected CPD plans are being generated. You can access the CPD plans by viewing your Downloads folder.",
        containerClassName: "success"
      }
    });

    const generatePlanPdfObservables: Observable<PdfResponse>[] = [];

    if (isSimplified == undefined) {
      generatePlanPdfObservables.push(this.pdfService.generatePlanPdf(this.plan.Id, true));
      generatePlanPdfObservables.push(this.pdfService.generatePlanPdf(this.plan.Id, false));
    } else {
      generatePlanPdfObservables.push(this.pdfService.generatePlanPdf(this.plan.Id, isSimplified))
    }

    forkJoin(generatePlanPdfObservables).subscribe({
      next: (responses: PdfResponse[]) => {
        forEach(responses, response => saveAs(response.data, response.fileName))
      },
      error: () => {
        this.openSnackbarError("Unable to generate PDF(s).");
      },
      complete: () => {
        this.isDownloadingPdf = false;
        this.dialog.closeAll();
      }
    });
  }

  emailPdf(isSimplified?: boolean) {
    this.isSendingPdfEmail = true;
    this.dialog.open(DialogLoadingComponent, {
      width: "600px",
      disableClose: true,
      data: {
        message: "Your selected CPD plan(s) are being generated. You will receive an email that includes the CPD plan(s) in the next few minutes.",
        srMessage: "Your selected CPD plans are being generated. You will receive an email that includes the CPD plans in the next few minutes.",
        containerClassName: "success"
      }
    });
    this.pdfService.emailPlanPdf(this.plan.Id, isSimplified).subscribe({
      error: () => {
        this.openSnackbarError("Unable to generate PDF.");
      },
      complete: () => {
        this.isSendingPdfEmail = false;
        this.dialog.closeAll();
      }
    });
  }

  openSnackbarError(message: string) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: message, panelClass: 'snackbar-error'
    });
  }

  openSnackbarInfo(message: string) {
    this._snackBar.openFromComponent(SnackbarComponent, {
      data: message, panelClass: 'snackbar', duration: 2000
    });
  }
}
